export default "__VITE_ASSET__BJhLUdTa__"